<template>
    <v-container align="center">
      <div class="mainDisplayButtons" style="margin-bottom: 6px; display: flex; align-items: center; justify-content: center; flex-wrap: wrap; gap: 4px;">
        <v-btn small @click="mainDisplay=ENTER_SESSION" class="mx-1" color="primary" variant="outlined" :active="mainDisplay === ENTER_SESSION">Enter Session</v-btn>
        <v-btn small @click="goToReports" class="mx-1" color="primary" variant="outlined" :active="isReportView">Reports</v-btn>
        <v-btn small @click="mainDisplay=EDIT_SESSIONS" class="mx-1" color="primary" variant="outlined" :active="mainDisplay === EDIT_SESSIONS">Edit the Past</v-btn>
      </div>
      <div v-if="isReportView" style="margin-bottom: 10px; display: flex; align-items: center; justify-content: center; flex-wrap: wrap; gap: 4px;">
        <v-btn small @click="mainDisplay=SHOW_GRAPH" class="mx-1" color="secondary" variant="outlined" :active="mainDisplay === SHOW_GRAPH">Graph</v-btn>
        <v-btn small @click="mainDisplay=SHOW_PLACES" class="mx-1" color="secondary" variant="outlined" :active="mainDisplay === SHOW_PLACES">By Place</v-btn>
        <v-btn small @click="mainDisplay=SHOW_DAYS" class="mx-1" color="secondary" variant="outlined" :active="mainDisplay === SHOW_DAYS">Top Time</v-btn>
      </div>
    </v-container>
  

  <GraphDisplay v-if="mainDisplay===SHOW_GRAPH" @drilldown="handleDrilldown" />
  <PlacesReport v-if="mainDisplay===SHOW_PLACES" @drilldown="handleDrilldown" />
  <DaysReport v-if="mainDisplay===SHOW_DAYS" @drilldown="handleDrilldown" />
  <EditSessions v-if="mainDisplay===EDIT_SESSIONS" :filters="filters" @dataedited="sessionsEdited" />
  <v-container v-if="mainDisplay===ENTER_SESSION" >
    <div class="entry-title" >
      <h2 v-if="checkin && !datalist.checkedin && datalist.checkin.type === CASH">Sit at a Cash Session</h2>
      <h2 v-if="checkin && !datalist.checkedin && datalist.checkin.type === TOURNAMENT">Start a New Tournament</h2>
      <h2 v-if="checkin && datalist.checkedin && datalist.checkedintype === TOURNAMENT">Checkout of the Tournament</h2>
      <h2 v-if="checkin && datalist.checkedin && datalist.checkedintype === CASH">Checkout of the Cash Session</h2>
      <h2 v-if="!checkin && datalist.checkin.type === CASH">Enter a complete Cash session</h2>
      <h2 v-if="!checkin && datalist.checkin.type === TOURNAMENT">Enter a complete Tournament</h2>
    </div>

    <v-card>
      <v-tabs v-if="!datalist.checkedin || !checkin" align-tabs="center" >
        <v-tab :active="datalist.checkin.type === CASH" @click="cashClick">Cash</v-tab>
        <v-tab :active="datalist.checkin.type === TOURNAMENT" @click="tournamentClick">Tournament</v-tab>
      </v-tabs>

      <v-card-text>
        <div align-card="center" style="display: flex; flex-wrap: wrap; justify-content: center; gap: 8px; margin-bottom: 8px;">
          <v-btn pill :class="{ 'v-btn--active': !checkin }" @click="FullEntryClick">Full Session</v-btn>
          <v-btn pill v-if="!datalist.checkedin" :class="{ 'v-btn--active':checkin}" @click="CheckinClick">Session Checkin</v-btn>
          <v-btn pill v-if="datalist.checkedin" :class="{ 'v-btn--active':checkin}" @click="CheckoutClick">Session Checkout</v-btn>
          <v-btn pill v-if="datalist.checkedin" :class="{ 'v-btn--active':false}" @click="DeleteCheckout">Delete Checked in Session</v-btn>
        </div>

        <CashCheckout v-if="datalist.checkin.type === CASH && !checkin" :datalist="datalist" @entered="cashSession" />
        <CashCheckout v-if="datalist.checkin.type === CASH && checkin && datalist.checkedin" :datalist="datalist" @entered="cashCheckout" />
        <CashCheckin v-if="datalist.checkin.type === CASH && checkin && !datalist.checkedin" :datalist="datalist" @entered="cashCheckin" />
        <TournamentCheckout v-if="datalist.checkin.type === TOURNAMENT && !checkin" :datalist="datalist" @entered="tournamentSession" />
        <TournamentCheckout v-if="datalist.checkin.type === TOURNAMENT && checkin && datalist.checkedin" :datalist="datalist" @entered="tournamentCheckout" />
        <TournamentCheckin v-if="datalist.checkin.type === TOURNAMENT && checkin && !datalist.checkedin" :datalist="datalist" @entered="tournamentCheckin" />
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script setup>
import { ref, onMounted, computed, watch } from 'vue';
import { useUserStore } from '@/stores/users';
import { useSessionStore } from '@/stores/sessions';
import { usePlaceStore } from '@/stores/places';
import { useGameStore } from '@/stores/games';
import { USERS_DB, CASH, TOURNAMENT, NO_LIMIT, SHOW_GRAPH, ENTER_SESSION, EDIT_SESSIONS, SHOW_PLACES, SHOW_DAYS } from '@/constants/constants';
import { db } from '@/firebaseConfig';
//import { getAuth } from 'firebase/auth';
import { doc, updateDoc, deleteDoc } from 'firebase/firestore';
import CashCheckout from '@/components/custom/CashCheckout.vue';
import CashCheckin from '@/components/custom/CashCheckin.vue';
import TournamentCheckout from '@/components/custom/TournamentCheckout.vue';
import TournamentCheckin from '@/components/custom/TournamentCheckin.vue';
import GraphDisplay from '@/components/custom/GraphDisplay.vue';
import EditSessions from '@/components/custom/EditSessions.vue';
import PlacesReport from '@/components/custom/PlacesReport.vue';
import DaysReport from '@/components/custom/DaysReport.vue';


const mainDisplay = ref(ENTER_SESSION);
const REPORT_VIEWS = [SHOW_GRAPH, SHOW_PLACES, SHOW_DAYS];
const isReportView = computed(() => REPORT_VIEWS.includes(mainDisplay.value));

function goToReports() {
  if (!isReportView.value) mainDisplay.value = SHOW_GRAPH;
}

const filters = ref({
  gamefilter: [],
  typefilter: null,
  fromDate: { date: new Date(2019, 8, 1) },
  toDate: { date: new Date() },
  placefilter: [],
  bettypefilter: []
});

function handleDrilldown(drillFilters) {
  filters.value = drillFilters;
  mainDisplay.value = EDIT_SESSIONS;
}

const checkin = ref(false);
const userStore = useUserStore();
const sessionStore = useSessionStore();
const datalist = ref({
  checkin: {
    sessiondate: new Date(),
    sessionstartdate: new Date(),
    type: TOURNAMENT,
    bettype: NO_LIMIT,
    place: '',
    notes: ''
  },
  checkedin: false,
  user: {},
  checkedintype: null
});

const user = computed(() => userStore.user);
const placeStore = usePlaceStore();
const gameStore = useGameStore();


onMounted(async () => {
  // Use the user object from the store, which is already populated.
  if (user.value) {
    datalist.value.user = user.value;
    // The user object from the store doesn't have the doc.id, so we can get it if needed,
    // but for permissions, the user object itself is enough.
    datalist.value.checkedin = false;
    if (user.value.checkin) {
      datalist.value.checkedin = true;
      datalist.value.checkin = user.value.checkin;
      datalist.value.checkedintype = user.value.checkin.type;
    }
    // Fetch sessions for the current user when the view mounts
    sessionStore.createSessionList().catch(err => {
      console.error('Error creating session list on mount:', err);
    });
    // Fetch place and game lists for comboboxes
    placeStore.createPlaceList().catch(err => {
      console.error('Error creating place list on mount:', err);
    });
    gameStore.createGamesList().catch(err => {
      console.error('Error creating games list on mount:', err);
    });
  }
});

// Watch for the user becoming available (e.g., after login) and fetch sessions
watch(user, (newUser) => {
  if (newUser) {
    sessionStore.createSessionList().catch(err => {
      console.error('Error creating session list on user change:', err);
    });
    placeStore.createPlaceList().catch(err => {
      console.error('Error creating place list on user change:', err);
    });
    gameStore.createGamesList().catch(err => {
      console.error('Error creating games list on user change:', err);
    });
  } else {
    // Clear session list when no user is present
    sessionStore.sessionlist = [];
  }
});

const cashSession = payload => {
  sessionStore.addSession({ vm: this, session: payload.newrecord }).catch(err => {
    console.error('error on add of new session', err);
  });
};

const cashCheckin = payload => {
  const newrecord = payload.newrecord;

  updateDoc(doc(db, USERS_DB, userStore.userid), { checkin: newrecord })
    .then(() => {
      checkin.value = true;
      datalist.value.checkedin = true;
      datalist.value.checkedintype = CASH;
      datalist.value.checkin = newrecord;
    })
    .catch(err => {
      console.error('Error on add of checkin:', err);
    });
};

const cashCheckout = payload => {
  sessionStore
    .addSession({ vm: this, session: payload.newrecord })
    .then(() => {
      updateDoc(doc(db, USERS_DB, userStore.userid), {
        checkin: deleteDoc()
      })
        .then(() => {
          datalist.value.checkedin = false;
          checkin.value = false;
        })
        .catch(err => {
          console.error('Error on delete of checkin:', err);
        });
    })
    .catch(err => {
      console.error('Error on add of new session:', err);
    });
};

const tournamentSession = payload => {
  //console.log('tournamentSession sessionentry payload', payload.newrecord);
  sessionStore.addSession( {session: payload.newrecord} ).catch(err => {
    console.error('error on add of new session', err);
  });
};

const tournamentCheckin = payload => {
  const newrecord = payload.newrecord;
  updateDoc(doc(db, USERS_DB, userStore.userid), { checkin: newrecord })
    .then(() => {
      datalist.value.checkedin = true;
      datalist.value.checkedintype = TOURNAMENT;
      datalist.value.checkin = newrecord;
      checkin.value = true;
      //console.log('datalist after checkin', datalist.value.checkedintype, checkin.value);
    })
    .catch(err => {
      console.error('error on add of checkin', err);
    });
};

const tournamentCheckout = payload => {
  sessionStore
    .addSession({ vm: this, session: payload.newrecord })
    .then(() => {
      updateDoc(doc(db, USERS_DB, userStore.userid), {
        checkin: deleteDoc()
      })
        .then(() => {
          datalist.value.checkedin = false;
          checkin.value = false;
        })
        .catch(err => {
          console.error('error on delete of checkin', err);
        });
    })
    .catch(err => {
      console.error('error on add of new session', err);
    });
};



const cashClick = () => {
  datalist.value.checkin.type = CASH;
};

const tournamentClick = () => {
  datalist.value.checkin.type = TOURNAMENT;
};

const CheckinClick = () => {
  checkin.value = true;
};

const CheckoutClick = () => {
  checkin.value = true;

};

const DeleteCheckout = async () => {
  try {
    const { updateDoc, doc, deleteField } = await import('firebase/firestore');
    await updateDoc(doc(db, USERS_DB, userStore.userid), {
      checkin: deleteField()
    });
    datalist.value.checkedin = false;
    checkin.value = false;
  } catch (err) {
    console.error('error on delete of checkin', err);
  }
};

const FullEntryClick = () => {
  checkin.value = false;
};
</script>

<style>
.winnings {
  font-size: 24px;
  margin-top: 20px;
}
.enterform {
  max-width: 500px;
  width: 80%;
  margin: 0 auto;
  position: relative;
}
.input {
  border: medium none !important;
  margin: 0 0 10px;
  padding-left: 6px;
  min-width: 100%;
  padding: 0;
  width: 100%;
}
.checkbox {
  padding-top: 60px
}
.label {
  text-align: left;
  padding-left: 0px;
  color: black;
}
.sessionentry h2 {
  font-size: 1.3em;
}
.entry-title {
  text-align: center;
  padding-top: 30px;
}
.chart {
  width: 100%;
  margin-bottom: 40px;
  margin-top: 40px;
}
.my-buttons {
  width: 40%;
  text-align: center;
}
.btn {
  margin-top: 10px;
}
.test.disabled {
  color: black;
}
</style>